/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_SavedInputs */

const cs_ebr_conn_saved = /** @type {(inputs: Ebr_Conn_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojení k eBráně uloženo`)
};

const en_ebr_conn_saved = /** @type {(inputs: Ebr_Conn_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána connection saved`)
};

/**
* | output |
* | --- |
* | "eBrána connection saved" |
*
* @param {Ebr_Conn_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_saved = /** @type {((inputs?: Ebr_Conn_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_saved(inputs)
	return cs_ebr_conn_saved(inputs)
});